import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CfetPageNamesConstant } from '../cfet-core';
import { CfetLandingComponent } from '../../app/cfet-landing/cfet-landing.component';
import { AuthGuardService } from '../services/auth-guard.service';
import {
    AffiliationCodeComponent, AffiliationCodeUtfComponent, CustomerEligibilityComponent, CustomerInformationComponent,
    CustomerProfileComponent, CustomerInformationUtfComponent, CustomerProfileUtfComponent, CompleteProfileComponent,
    SessionTimeOutComponent, SessionTimeOutUtfComponent, ErrorPageComponent, ErrorPageUtfComponent,
    UtfRegistrationVerifyComponent, UtfAuthPageComponent, CustomerEligibilityUtfComponent, CompleteProfileUtfComponent,
    UtfAuthSingleIdComponent, UtfUnauthPageComponent, UtfSyncInfoComponent, UtfSyncingInformationComponent
} from './index';
import { UtfLandingComponent } from '../cfet-landing/utf-landing/utf-landing.component';
import { UtfLandingNewComponent } from '../cfet-landing/utf-landing/utf-landing-new/utf-landing-new.component';
import { CustomerEligibilityUtfCompletionComponent, CustomerEligibilityUtfFormComponent } from '../cfet-page-components';

const routes: Routes = [
    {
        path: '',
        children: [
            { path: "", component: CfetLandingComponent, outlet: "cfet" },
            { path: "", component: UtfLandingComponent, outlet: "utf" }
        ]
    },
    {
        path: CfetPageNamesConstant.CUSTOMER_ELIGIBILITY,
        component: CustomerEligibilityComponent
    },
    {
  path: CfetPageNamesConstant.CUSTOMER_ELIGIBILITY_UTF,
  component: CustomerEligibilityUtfComponent,
  canActivate: [AuthGuardService],
  children: [
    {
      path: '',
            component:CustomerEligibilityUtfFormComponent
    },
    {
      path: 'completion',
      component: CustomerEligibilityUtfCompletionComponent
    }
  ]
},
    {
        path: CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION,
        component: CustomerInformationComponent
    }, {
        path: CfetPageNamesConstant.CUSTOMER_PERSONAL_INFORMATION_UTF,
        component: CustomerInformationUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.CUSTOMER_LANDING,
        component: UtfLandingComponent
    },
    {
        path:'orgassignment',
        redirectTo:'orgAssignment',
        pathMatch:'full'
    },
    {
        path: CfetPageNamesConstant.CUSTOMER_LANDING_UTF_NEW,
        component: CustomerEligibilityUtfComponent,
      children: [
        {
            path:'',
            component:CustomerEligibilityUtfFormComponent
        }
      ]
    },
    {
        path: CfetPageNamesConstant.CUSTOMER_PROFILE,
        component: CustomerProfileComponent
    },
    {
        path: CfetPageNamesConstant.CUSTOMER_PROFILE_UTF,
        component: CustomerProfileUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.AFFILIATION_CODE,
        component: AffiliationCodeComponent
    }, {
        path: CfetPageNamesConstant.AFFILIATION_CODE_UTF,
        component: AffiliationCodeUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION,
        component: CompleteProfileComponent
    }, {
        path: CfetPageNamesConstant.COMPLETE_PROFILE_CONFIRMATION_UTF,
        component: CompleteProfileUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.SESSION_TIME_OUT,
        component: SessionTimeOutComponent
    }, {
        path: CfetPageNamesConstant.SESSION_TIME_OUT_UTF,
        component: SessionTimeOutUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.ERROR_PAGE,
        component: ErrorPageComponent
    }, {
        path: CfetPageNamesConstant.ERROR_PAGE_UTF,
        component: ErrorPageUtfComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_REGISTRATION,
        component: UtfRegistrationVerifyComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_AUTH_PAGE,
        component: UtfAuthPageComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_SYNC_DETAILS_PAGE,
        component: UtfSyncInfoComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_SYNCING_INFO,
        component: UtfSyncingInformationComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_UNAUTH_PAGE,
        component: UtfUnauthPageComponent,
        canActivate: [AuthGuardService]
    }, {
        path: CfetPageNamesConstant.UTF_AUTH_SINGLE_ID_PAGE,
        component: UtfAuthSingleIdComponent,
        canActivate: [AuthGuardService]
    }, {
        path: '**',
        redirectTo: '/page-not-found'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class CfetScreensRoutingModule { }
